import Component from "vue-class-component";
import Vue from "vue";
import { InputCurrencyCreate, InputCurrencyUpdate } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import providers from "@/lib/providers";

@Component({ name: "WithCurrency" })
export default class WithCurrency extends Vue {
  public currencyFindAll() {
    return providers.CurrencyProvider.findAll();
  }

  public currencyCreate(payload: { data: InputCurrencyCreate }) {
    return providers.CurrencyProvider.create(payload);
  }

  public currencyUpdate(payload: { data: InputCurrencyUpdate }) {
    return providers.CurrencyProvider.update(payload);
  }

  public currencyDelete(payload: { name: string }) {
    return providers.CurrencyProvider.delete(payload);
  }
}
